export default __webpack_public_path__ + "static/media/tf.e204d275.svg";